import React from 'react'

export const FilterCell = (): JSX.Element => {
  return <React.Fragment />
}
